import _last from 'lodash/last';
import _first from 'lodash/first';
import { TrackingCheckpoint } from './TrackingCheckpoint/TrackingCheckpoint.js';
import { TrackingLastUpdateLabel } from './TrackingLastUpdateLabel.js';
import { TrackingCheckpointDecoration } from './TrackingCheckpointDecoration/TrackingCheckpointDecoration.js';
import { getTrackingTimelineItemStyles, getTrackingTimelineLastUpdateLabelStyles, getTrackingTimelineCheckpointDecorationStyles, getTrackingCheckpointStyles } from './TrackingTimelineStyles.js';
import { useMemo } from 'react';
import { useTheme } from '@emotion/react';
import { useMedia } from '@packlink/utils';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

function TrackingTimeline(_ref) {
  let {
    checkpoints,
    ...otherProps
  } = _ref;
  const orderedCheckpoints = useMemo(() => checkpoints.slice().reverse(), [checkpoints]);
  const theme = useTheme();
  const isFromTablet = useMedia(theme.mediaQuery('tablet'));
  return jsx("ul", {
    ...otherProps,
    children: orderedCheckpoints.map((checkpoint, index) => {
      const isLatestCheckpoint = checkpoint === _last(orderedCheckpoints);
      const isInitialCheckpoint = checkpoint === _first(orderedCheckpoints);
      const isSingleCheckpoint = orderedCheckpoints.length === 1;
      const hasDecorativeLine = !isLatestCheckpoint && orderedCheckpoints.length > 1;
      return jsxs("li", {
        css: getTrackingTimelineItemStyles,
        "data-id": "tracking-checkpoint",
        children: [isInitialCheckpoint && isFromTablet && jsx(TrackingLastUpdateLabel, {
          css: getTrackingTimelineLastUpdateLabelStyles(isSingleCheckpoint),
          "data-id": "timeline-last-update-label"
        }), jsx(TrackingCheckpointDecoration, {
          css: getTrackingTimelineCheckpointDecorationStyles,
          isLatestCheckpoint: isLatestCheckpoint,
          isInitialCheckpoint: isInitialCheckpoint,
          hasDecorativeLine: hasDecorativeLine
        }), jsx(TrackingCheckpoint, {
          css: getTrackingCheckpointStyles,
          checkpoint: checkpoint,
          isFromTablet: isFromTablet,
          important: isInitialCheckpoint
        })]
      }, `${checkpoint.status}-${index}`);
    })
  });
}

export { TrackingTimeline };
//# sourceMappingURL=TrackingTimeline.js.map
